const VITE_APP_FLOW = import.meta.env.VITE_APP_FLOW;

export const isStaff = VITE_APP_FLOW === 'staff';
export const isUser = VITE_APP_FLOW === 'user';
export const isAdmin = !isStaff && !isUser;
